export interface IPortalTopicWidgetState {
    title: string,
    introText: string,
    subtopics: IPortalSubtopic[],
}

export interface IPortalSubtopic {
    title: string,
    introText: string,
    bodyText: string,
}

export class PortalTopicWidgetState implements IPortalTopicWidgetState {
    title: string = '';
    introText: string = '';
    subtopics: IPortalSubtopic[] = [];
}